import * as React from 'react';
import {FunctionComponent} from 'react';
import {CalendarEvent} from '../../../../../Models/CalendarEvent';
import {addSeconds, format} from 'date-fns';
import {utcToZonedTime} from 'date-fns-tz';
import {FullCrew} from '../../../../../Models/Crew';
import {RsvpResponseCell} from '../../Components/RsvpResponseCell/RsvpResponseCell';
import {RsvpResponseButtons} from '../../Components/RsvpResponseButtons/RsvpResponseButtons';
import {Me} from '../../../../../Models/Me';

interface OwnProps {
    me: Me;
    crew: FullCrew;
    calendarEvent: CalendarEvent;
    onRequestClose: () => void;
    onRequestEdit: () => void;
}

export const ViewScheduledEvent: FunctionComponent<OwnProps> = ({
    me,
    crew,
    calendarEvent,
    onRequestEdit,
    onRequestClose,
}) => {
    const startAt = utcToZonedTime(calendarEvent.startAt, calendarEvent.timezone);
    return (
        <>
            <div className="modal-header d-flex justify-content-between">
                <h5 className="modal-title">Event</h5>
                <span className="d-flex">
                    <button onClick={() => onRequestEdit()} className="btn btn-transparent">
                        Edit
                    </button>
                    <button onClick={() => onRequestClose()} className="btn btn-transparent me-2">
                        Close
                    </button>
                </span>
            </div>
            <div className="modal-body">
                <div className="row">
                    <div className="col-12 col-sm-6">
                        <div className="d-flex justify-content-between">
                            <strong>{calendarEvent.title}</strong>
                            <span>
                                {format(startAt, 'eeeeee d LLL') +
                                    ' ' +
                                    format(startAt, 'H:mm') +
                                    ' - ' +
                                    format(addSeconds(startAt, calendarEvent.duration.seconds), 'H:mm')}
                            </span>
                        </div>
                        <p>{calendarEvent.description}</p>
                    </div>
                    <div className="col-12 col-sm-6">
                        <strong>Crew</strong>
                        <div className="d-flex flex-column gap-2">
                            {calendarEvent.rsvpStatuses.map((rsvp) => {
                                const crewMember = crew.members.find((member) => member.userId === rsvp.userId);
                                if (crewMember === undefined) {
                                    return;
                                }
                                return (
                                    <div key={rsvp.userId} className="d-flex flex-row gap-2 align-items-baseline">
                                        <RsvpResponseCell tiny userId={rsvp.userId} calendarEvent={calendarEvent} />
                                        {crewMember.firstName + ' ' + crewMember.lastName}
                                    </div>
                                );
                            })}
                        </div>
                    </div>
                </div>
            </div>
            <div className="modal-footer justify-content-end">
                <RsvpResponseButtons userId={me.id} calendarEvent={calendarEvent} />
            </div>
        </>
    );
};
